<template>
  <div class="register_page">
    <div class="header">
      <h3>一级用户注册</h3>
      <div class="gray">请如实填写集团/企业以下认证信息。</div>
    </div>
    <el-row :gutter="100">
      <el-form class="registerForm" :model="registerForm" :rules="registerRule" ref="registerForm" label-width="100px" label-position="top">
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" style="border-right: 1px solid rgba(80, 88, 105, 0.25)">
          <el-form-item label="注册邮箱" prop="registerMail">
            <el-input v-model="registerForm.registerMail" placeholder="请输入注册邮箱" clearable></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="registerForm.password" type="password" placeholder="请输入密码" clearable></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="againPassword">
            <el-input v-model="registerForm.againPassword" type="password" placeholder="请输入确认密码" clearable></el-input>
          </el-form-item>
          <el-form-item label="目前所涉及的行业" required>
            <el-cascader
              ref="tradeList"
              v-model="selected_trade"
              :options="tradeList"
              :props="props_cascader"
              clearable
              @change="handleChange"
              placeholder="请选择目前所涉及的行业"
              size="small"
              style="width: 100%"></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item label="企业名称" prop="enterprieName">
            <el-input v-model="registerForm.enterprieName" placeholder="请输入企业名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="企业Logo" prop="logo">
            <el-input v-model="registerForm.logo" placeholder="请上传企业Logo" disabled>
              <el-upload slot="append" class="upload-demo" :action="uploadUrl" :show-file-list="false" :http-request="uploadImg_logo">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-input>
          </el-form-item>
          <el-form-item label="企业电话" prop="enterpriePhone">
            <el-input v-model="registerForm.enterpriePhone" placeholder="请输入企业电话" clearable></el-input>
          </el-form-item>
          <el-form-item label="企业邮箱" prop="enterprieMail">
            <el-input v-model="registerForm.enterprieMail" placeholder="请输入企业邮箱" clearable></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码">
            <el-input v-model="registerForm.code" placeholder="请输入统一社会信用代码" clearable></el-input>
          </el-form-item>
          <el-form-item label="营业执照">
            <el-input v-model="registerForm.businessLicense" placeholder="请上传营业执照" disabled>
              <el-upload slot="append" class="upload-demo" :action="uploadUrl" :show-file-list="false" :http-request="uploadImg_businessLicense">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item label="企业法人" prop="enterpriseLegalPerson">
            <el-input v-model="registerForm.enterpriseLegalPerson" placeholder="请输入企业法人" clearable></el-input>
          </el-form-item>
          <el-form-item label="法人联系方式" prop="enterpriseLegalPersonPhone">
            <el-input v-model="registerForm.enterpriseLegalPersonPhone" placeholder="请输入法人联系方式" clearable></el-input>
          </el-form-item>
          <el-form-item label="企业联系人" prop="enterprieContacts">
            <el-input v-model="registerForm.enterprieContacts" placeholder="请输入企业联系人" clearable></el-input>
          </el-form-item>
          <el-form-item label="联系人电话" prop="contactsPhone">
            <el-input v-model="registerForm.contactsPhone" placeholder="请输入联系人电话" clearable></el-input>
          </el-form-item>
          <el-form-item label="联系人邮箱" prop="contactsMail">
            <el-input v-model="registerForm.contactsMail" placeholder="请输入联系人邮箱" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-row type="flex" justify="center" style="margin-top: 60px">
      <el-button type="primary" @click="toRegister('registerForm')" style="width: 23%; min-width: 300px">发起注册审批</el-button>
    </el-row>
    <el-row type="flex" justify="center">
      <el-button type="text" @click="$router.push('/')">账号登录</el-button>
    </el-row>
    <!-- 上传图片截图工具 -->
    <cropper ref="myCroppr" @emitt="callBack"></cropper>
  </div>
</template>
<script>
import cropper from '../../components/cropper.vue';
export default {
  name: 'registerForm',
  components: { cropper },
  data() {
    let checkPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入您的密码'));
      } else {
        const reg = /^(\w){6,20}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('密码由6-20个字母、数字、下划线组成，请重新输入'));
        }
      }
    };
    let checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入您的手机号'));
      } else {
        const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };
    // 重复密码验证
    let pwdAgainCheck = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('重复密码不能为空'));
      } else {
        if (this.registerForm.password == this.registerForm.againPassword) {
          callback();
        } else {
          return callback(new Error('两次输入密码不一致'));
        }
      }
    };
    let checkEmai = (rule, value, callback) => {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!value) {
        callback(new Error('请输入企业邮箱'));
      } else if (!emailRegex.test(value)) {
        callback(new Error('请输入正确的邮箱格式'));
      } else {
        callback();
      }
    };
    return {
      uploadUrl: `${process.env.BASE_URL}api/file/upload`,
      registerForm: {
        registerMail: '',
        password: '',
        againPassword: '',
        business: '',
      },
      registerRule: {
        registerMail: [
          { required: true, message: '请输入注册邮箱', trigger: 'blur' },
          { validator: checkEmai, trigger: 'change' },
          { validator: checkEmai, trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入您的密码', trigger: 'blur' },
          { validator: checkPwd, trigger: 'blur' },
        ],
        againPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: pwdAgainCheck, trigger: 'blur' },
        ],
        industryCategory: [{ required: true, message: '请选择行业', trigger: 'blur' }],
        enterprieName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        logo: [{ required: true, message: '请上传企业logo', trigger: 'blur' }],
        enterpriePhone: [
          { required: true, message: '请输入企业电话', trigger: 'blur' },
        ],
        enterprieMail: [
          { required: true, message: '请输入企业邮箱', trigger: 'blur' },
          { validator: checkEmai, trigger: 'change' },
        ],
        enterprieContacts: [{ required: true, message: '请输入企业联系人', trigger: 'blur' }],
        contactsPhone: [
          { required: true, message: '请输入联系人电话', trigger: 'blur' },
          { validator: checkPhone, trigger: 'change' },
        ],
        contactsMail: [
          { required: true, message: '请输入联系人邮箱', trigger: 'blur' },
          { validator: checkEmai, trigger: 'change' },
        ],
        enterpriseLegalPerson: [{ required: true, message: '请输入企业法人', trigger: 'blur' }],
        enterpriseLegalPersonPhone: [
          { required: true, message: '请输入法人联系方式', trigger: 'blur' },
          { validator: checkPhone, trigger: 'change' },
        ],
      },
      props_cascader: {
        expandTrigger: 'hover',
        multiple: true,
        label: 'name',
        value: 'id',
        children: 'industryCategoryList',
      },
      selected_trade: [],
      tradeList: [
        { id: 0, name: '农业' },
        { id: 1, name: '林业' },
        { id: 2, name: '畜牧业' },
      ],
      // 附件
      files_logo: [],
      files_businessLicense: [],
    };
  },
  created() {
    this.getBusinessList();
  },
  methods: {
    // 获取行业列表
    getBusinessList() {
      this.$axios
        .post(`${process.env.BASE_URL}api/industry/industryList`, { keyWords: '', page: 1, limit: 999999, isUse: 1 })
        .then((res) => {
          if (res.data.code === 200) {
            this.tradeList = Object.assign([], res.data.page.list);
          } else {
            this.$message({
              type: 'error',
              message: '查询失败-' + res.data.msg,
              offset: 80,
            });
          }
        })
        .catch((err) => {});
    },
    handleChange(val) {
      this.selected_trade = val;
    },
    //注册
    toRegister(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$set(this.registerForm, 'tier', 1); //层级tier
          let kes_files = ['logo', 'businessLicense'];
          kes_files.forEach((key, i) => {
            let params = [];
            this['files_' + key].forEach((e) => {
              let file = { name: e.name, url: e.url };
              params.push(file);
            });
            this.$set(this.registerForm, kes_files[i], JSON.stringify(params));
          });
          // 放置目前所涉及的行业数组
          let industryArr = [];
          this.selected_trade.forEach((arrItem) => {
            industryArr.push(arrItem.join('-'));
          });
          this.$set(this.registerForm, 'industryCategory', industryArr.join(','));
          this.$axios
            .post('api/user/register', this.registerForm)
            .then((res) => {
              if (res.data.code === 200) {
                this.$message({
                  showClose: true,
                  message: '注册成功',
                  offset: 80,
                  type: 'success',
                });
                this.$router.push('/');
              } else {
                this.$message({
                  showClose: true,
                  message: '注册失败-' + res.data.msg,
                  offset: 80,
                  type: 'error',
                });
                let kes_files = ['logo', 'businessLicense'];
                kes_files.forEach((key, i) => {
                  this['files_' + key] = [];
                  this.$set(this.registerForm, kes_files[i], []);
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    login() {
      this.$router.push('/');
    },
    uploadImg_logo(fileObj) {
      this.$refs.myCroppr.changeUpload(fileObj, 'logo');
    },
    uploadImg_businessLicense(fileObj) {
      this.$refs.myCroppr.changeUpload(fileObj, 'businessLicense');
    },
    // 图标上传回调
    callBack(data) {
      this.$message({ message: `上传成功`, type: 'success' });
      if (data.type == 'logo') {
        this.files_logo = [{ name: data.name, url: data.url }];
        this.$set(this.registerForm, 'logo', data.name);
      } else {
        this.files_businessLicense = [{ name: data.name, url: data.url }];
        this.$set(this.registerForm, 'businessLicense', data.name);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.register_page {
  padding: 5% 7%;
  .header {
    margin-bottom: 38px;
  }
}
</style>
